// @flow
import { rgba } from 'polished';
import styled from 'styled-components';

const buttonHeight = '2.5em';
const circleMargin = '0.25em';
const circleSize = (height = buttonHeight, margin = circleMargin) => `calc(${height} - ${margin})`;
const widthOffset = '1.5em';

export const Checkbox = styled.input`
    height: 1px;
    position: absolute;
    visibility: hidden;
    width: 1px;
`;
export const Switch = styled.span`
    cursor: pointer;
    display: block;
    background-color: ${props => props.theme.offlineGrey};
    border-radius: ${buttonHeight};
    box-shadow: ${({ isOn, theme }) =>
        isOn ? `inset 0 0 0 2em ${theme.mainBrandColor}` : `inset 0 0 0 0 ${rgba(theme.mainBrandColor, 0.75)}`};
    height: ${buttonHeight};
    position: relative;
    transition: all 0.2s ease 0.1s;
    width: calc(${buttonHeight} + ${widthOffset});
    &:after {
        content: '';
        cursor: pointer;
        display: block;
        background-color: ${props => props.theme.white};
        border-radius: ${circleSize()};
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
        height: ${circleSize()};
        margin-left: calc(${circleMargin} / 2);
        position: relative;
        top: calc(${circleMargin} / 2);
        transform: ${props => (props.isOn ? `translateX(${widthOffset})` : 'none')};
        transition: transform 0.2s ease;
        width: ${circleSize()};
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/toggle/styles.js